import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    MenuItem,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import {
    SelectValidator,
    TextValidator,
    ValidatorForm,
} from 'react-material-ui-form-validator';
import { useDispatch, useSelector } from 'react-redux';
import { AREAS_FISICAS, MENU_RECLAMOS, MENU_TIPO_INGRESO_RECLAMO, MENU_TIPO_INGRESO_RECLAMO_ARRAY, RECLAMOS_ESTADOS } from '../../../../utils/constants';
import { TraerReclamosEnviadosAfiliado, cleanReclamosEnviados, setActiveBreadcrumbReclamos } from '../../../../actions/reclamos/reclamosActions';
import moment from "moment";
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from "@material-ui/pickers";
import { ListadoReclamosEnviados } from './ListadoReclamosEnviados';
import { TraerReclamosEnviadosEfector } from '../../../../actions/reclamos/reclamosEfectorActions';
import Buscador from '../../../../actions/ui/Buscador';
import { TraerReclamosEnviadosExternos } from '../../../../actions/reclamos/reclamosExternosActions';
import { getAreasFisicasAction } from '../../../../actions/usuarios/areasFisicas';

const today = new Date();
const oneMonthsAgo = new Date(today);
oneMonthsAgo.setMonth(today.getMonth() - 1);

const fechaActual = new Date();


export const ReclamosEnviados = (props) => {

    const [tipoIngreso, setTipoIngreso] = useState('');
    const { areasFisicas } = useSelector((state) => state.areasFisicas);
    const { areasFisicasUsuario } = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const tipoBusqueda = "Todos";
    const altaBaja = "Todos";
    const [open, setOpen] = useState(true);
    const [fechaInicio, setFechaInicio] = useState(oneMonthsAgo);
    const [fechaFin, setFechaFin] = useState(today);
    const [estado, setEstado] = useState('');
    const [dataAfiliado, setDataAfiliado] = useState(null);
    const [value, setValue] = useState(null);
    const [valueE, setValueE] = useState(null);
    const [cuit, setCuit] = useState(null);
    const [destino, setDestino] = useState(areasFisicasUsuario?.idArea !== AREAS_FISICAS.COMUNICACIONES ? areasFisicasUsuario?.idArea : null);
    const [subDestino, setSubDestino] = useState(areasFisicasUsuario?.idArea !== AREAS_FISICAS.COMUNICACIONES ? areasFisicasUsuario?.idSubArea : null);
    const [dataEfector, setDataEfector] = useState(null);
    const [openListaReclamos, setOpenListaReclamos] = useState(false);
    const { subtipoEfectores } = useSelector(
        (state) => state.tipoSubtipoEfectores
    );


    const arrayEstadosSolicitudes = [
        { id: RECLAMOS_ESTADOS.FINALIZADA, descripcion: 'Finalizada' },
        { id: RECLAMOS_ESTADOS.PENDIENTE, descripcion: 'Pendiente' },
        { id: RECLAMOS_ESTADOS.ANULADA, descripcion: 'Anulada' }
    ];

    useEffect(() => {
        dispatch(cleanReclamosEnviados());
    }, [])

    useEffect(() => {
        dispatch(getAreasFisicasAction());
    }, [dispatch]);

    const onSubmitHandler = () => {
        
        if (tipoIngreso === MENU_TIPO_INGRESO_RECLAMO.AFILIADO) {
            dispatch(TraerReclamosEnviadosAfiliado(estado, fechaInicio, fechaFin, dataAfiliado, destino, subDestino))
        } else if (tipoIngreso === MENU_TIPO_INGRESO_RECLAMO.PRESTADOR) {
            dispatch(TraerReclamosEnviadosEfector(estado, fechaInicio, fechaFin, dataEfector))
        } else if (tipoIngreso === MENU_TIPO_INGRESO_RECLAMO.EXTERNOS) {
            dispatch(TraerReclamosEnviadosExternos(estado, fechaInicio, fechaFin, cuit, destino, subDestino))
        }
        setOpenListaReclamos(true);
        setOpen(false);
    };


    const onClose = () => {
        setOpen(false);
        dispatch(setActiveBreadcrumbReclamos(MENU_RECLAMOS.DESELECCIONAR));
    };


    console.log(areasFisicasUsuario.idArea)
    console.log(destino);
    console.log(subDestino)
    return (
        <React.Fragment>
            {openListaReclamos && (
                <ListadoReclamosEnviados
                    open={openListaReclamos}
                    close={() => {
                        setOpenListaReclamos(false);
                    }}
                    tipoIngreso={tipoIngreso}
                    estado={estado}
                    fechaInicio={fechaInicio}
                    fechaFin={fechaFin}
                    idAfiliado={dataAfiliado}
                    idEfector={dataEfector}
                    cuit={cuit}
                    destino={destino}
                    subDestino={subDestino}
                />
            )}
            <Dialog fullWidth maxWidth="md" open={open} onClose={onClose}>
                <DialogTitle>Seleccione</DialogTitle>
                <DialogContent>
                    <ValidatorForm onSubmit={onSubmitHandler}>
                        <Grid container spacing={2}>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                style={{ alignSelf: 'center', paddingLeft: 16 }}
                            >

                                <SelectValidator
                                    fullWidth
                                    label="Seleccionar ingreso"
                                    name="tipoIngreso"
                                    value={tipoIngreso}
                                    onChange={(e) => setTipoIngreso(e.target.value)}
                                    validators={['required']}
                                    errorMessages={['Este campo es requerido']}
                                >
                                    {MENU_TIPO_INGRESO_RECLAMO_ARRAY.map((t, index) => (
                                        <MenuItem key={index}
                                            value={t.id}
                                        >
                                            {t.descripcion}
                                        </MenuItem>
                                    ))}
                                </SelectValidator>
                            </Grid>

                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                style={{ alignSelf: 'center', paddingLeft: 16 }}
                            >
                                <SelectValidator
                                    fullWidth
                                    label="Seleccionar Estado"
                                    name="Estado"
                                    value={estado}
                                    onChange={(e) => setEstado(e.target.value)}
                                    validators={['required']}
                                    errorMessages={['Este campo es requerido']}
                                >
                                    {arrayEstadosSolicitudes.map((t, index) => (
                                        <MenuItem key={index}
                                            value={t.id}
                                        >
                                            {t.descripcion}
                                        </MenuItem>
                                    ))}
                                </SelectValidator>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                style={{ alignSelf: 'center', paddingLeft: 16 }}
                            >
                                <SelectValidator
                                    fullWidth
                                    label="Área Destino"
                                    name="destino"
                                    disabled={areasFisicasUsuario?.idArea !== AREAS_FISICAS.COMUNICACIONES ? true : false}
                                    value={destino}
                                    onChange={(e) => {
                                        setDestino(e.target.value);
                                        setSubDestino(0)
                                    }}
                                >
                                    {areasFisicas.map((e) => (
                                        <MenuItem key={e.idArea} value={e.idArea}>
                                            {e.descripcionArea}
                                        </MenuItem>
                                    ))}
                                </SelectValidator>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                style={{ alignSelf: 'center', paddingLeft: 16 }}
                            >
                                {(destino !== null) && !(areasFisicas.find(e => e.idArea === destino).subAreas.length === 0) && (
                                    <SelectValidator
                                        fullWidth
                                        margin="normal"
                                        label="Subárea Destino"
                                        name="subDestino"
                                        disabled={destino === "" || areasFisicasUsuario?.idArea !== AREAS_FISICAS.COMUNICACIONES ? true : false}
                                        value={subDestino}
                                        onChange={(e) => {
                                            setSubDestino(e.target.value)
                                        }}
                                        validators={["required"]}
                                        errorMessages={["Este campo es obligatorio"]}

                                    >
                                        {destino && areasFisicas.find(e => e.idArea === destino).subAreas.map(subArea => (
                                            <MenuItem key={subArea.idSubArea} value={subArea.idSubArea}>
                                                {subArea.descripcionSubArea}
                                            </MenuItem>
                                        ))}
                                    </SelectValidator>
                                )
                                }
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                md={6}
                                lg={6}
                                style={{ alignSelf: 'center', paddingLeft: 16 }}
                            >
                                <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        label="Fecha Inicio"
                                        format="dd/MM/yyyy"
                                        // required={true}
                                        clearLabel="Limpiar"
                                        cancelLabel="Cancelar"
                                        value={
                                            moment(fechaInicio).isValid() ? moment(fechaInicio).format() : null
                                        }
                                        onChange={(date) => {
                                            setFechaInicio(date);
                                        }}
                                        KeyboardButtonProps={{
                                            "aria-label": "change date",
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                md={6}
                                lg={6}
                                style={{ alignSelf: 'center', paddingLeft: 16 }}
                            >
                                <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        label="Fecha Inicio"
                                        format="dd/MM/yyyy"
                                        // required={true}
                                        clearLabel="Limpiar"
                                        cancelLabel="Cancelar"
                                        value={
                                            moment(fechaFin).isValid() ? moment(fechaFin).format() : null
                                        }
                                        onChange={(date) => {
                                            setFechaFin(date);
                                        }}
                                        KeyboardButtonProps={{
                                            "aria-label": "change date",
                                        }}
                                    />
                                </MuiPickersUtilsProvider>

                            </Grid>
                            {tipoIngreso === MENU_TIPO_INGRESO_RECLAMO.AFILIADO &&
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={12}
                                    style={{ alignSelf: 'center', paddingLeft: 16 }}
                                >

                                    <Buscador
                                        value={value}
                                        variant="outlined"
                                        setValue={(val) => { setDataAfiliado(val.id_afiliado); setValue(val) }}
                                        label="Apellido y Nombre  |  CUIT  |  DNI  |  Numero Beneficiaria/o"
                                        noOptionText={"No se encuentra beneficiaria/o"}
                                        endpoint={(texto) =>
                                            `Afiliados/traerPorNombreoDNIoNroAfi/${texto}/${tipoBusqueda}/${altaBaja}`
                                        }
                                        getOptionLabel={(option) =>
                                            `${option.apellido_y_nombre} ${option.carnet} ${option.cuil} ${option.nro_doc}`
                                        }
                                        renderOption={(option) => (
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <span
                                                    style={
                                                        option.fecha_baja === null
                                                            ? { color: "green" }
                                                            : { color: "red" }
                                                    }
                                                >
                                                    {`${option.apellido_y_nombre}`}
                                                </span>
                                                <span
                                                    style={{
                                                        fontSize: 12,
                                                    }}
                                                >
                                                    {" "}
                                                    {`Nro Afi:${option.carnet} - CUIL:${option.cuil}`}
                                                </span>
                                            </div>
                                        )}
                                    />
                                </Grid>
                            }
                            {tipoIngreso === MENU_TIPO_INGRESO_RECLAMO.PRESTADOR &&
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={12}
                                    style={{ alignSelf: 'center', paddingLeft: 16 }}
                                >

                                    <Buscador
                                        value={valueE}
                                        variant="outlined"
                                        setValue={(val) => { setDataEfector(val.idEfectorFacturacion); setValueE(val) }}
                                        label="Razon Social  |  CUIT  |  IdEfector "
                                        noOptionText={"No se encuentra el efector"}
                                        endpoint={(texto) =>
                                            `EfectorFacturacion/Busqueda?parametros=${texto}&todos=${props.todos ?? false
                                            }`
                                        }
                                        getOptionLabel={(option) => {
                                            const subTipoEfector = subtipoEfectores.find(
                                                (subTipoEfector) =>
                                                    subTipoEfector.idSubTipoEfector === option.idSubTipoEfector
                                            )?.descripcionSubTipoEfector;
                                            return `${option.razonSocial} ${option.cuit} - ${subTipoEfector} -  ${option.efectorDomicilio?.calle} ${option.efectorDomicilio?.nro} ${option.efectorDomicilio?.nro}`;
                                        }}
                                        renderOption={(option) => {
                                            const subTipoEfector = subtipoEfectores.find(
                                                (subTipoEfector) =>
                                                    subTipoEfector.idSubTipoEfector === option.idSubTipoEfector
                                            )?.descripcionSubTipoEfector;
                                            return (
                                                <div style={{ display: "flex", flexDirection: "column" }}>
                                                    <span
                                                        style={{
                                                            color:
                                                                option.fechaBaja === null ||
                                                                    option.fechaBaja >= fechaActual.toISOString()
                                                                    ? "green"
                                                                    : "red",
                                                        }}
                                                    >{`${option.razonSocial} ${option.cuit} - ${subTipoEfector} -  ${option.efectorDomicilio?.calle} ${option.efectorDomicilio?.nro}`}</span>
                                                </div>
                                            );
                                        }}
                                    />
                                </Grid>
                            }
                            {tipoIngreso === MENU_TIPO_INGRESO_RECLAMO.EXTERNOS &&
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={12}
                                    style={{ alignSelf: 'center', paddingLeft: 16 }}
                                >

                                    <TextValidator
                                        margin="normal"
                                        label="CUIT o CUIL"
                                        name="cuit"
                                        value={cuit}
                                        autoComplete="off"
                                        onChange={(e) => setCuit(e.target.value)}
                                        fullWidth
                                        style={{ paddingRight: "0.5rem" }}
                                    />
                                </Grid>
                            }
                        </Grid>
                        <div
                            style={{
                                margin: '1rem 0',
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-evenly',
                            }}
                        >
                            <Button variant="contained" color="primary" onClick={onClose}>
                                Cancelar
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                //disabled={props.disabled}
                                color="primary"
                            >
                                Guardar
                            </Button>
                        </div>
                    </ValidatorForm>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}
